var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-medium m-auto" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading"
          }
        ],
        staticClass: "mx-5"
      },
      [
        _c(
          "terms-form",
          {
            attrs: {
              corporation: _vm.corporation,
              type: _vm.type,
              terms: _vm.terms
            },
            on: { load: _vm.load, "terms-accepted": _vm.callback }
          },
          [
            _c("template", { slot: "button" }, [
              _vm._v(
                _vm._s(
                  _vm._f("capitalize")(
                    _vm.$l10n.__("j'accepte les conditions générales")
                  )
                )
              )
            ])
          ],
          2
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }